import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingDeleteBackgroundConfig } from '@/data/landingConfig/landingDeleteBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_DeleteBackground } from './schemaObject';

interface Props {}
const DeleteBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_DeleteBackground} />
			<LandingTemplate
				data={landingDeleteBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default DeleteBackground;
